import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, CardLink, Input, Form, FormGroup, Label } from 'reactstrap';
import moment from 'moment';
import objectToFormdata from 'object-to-formdata';
import { toast } from 'react-toastify';
import { version } from '../util/animation';
import bytes from 'bytes';
import ReactTooltip from 'react-tooltip';
import { findDOMNode } from 'react-dom';
import { Resizable } from "re-resizable";
import ResizableWithControls from "./ResizableWithControls.jsx";
import AnimationPages from './AnimationPages.jsx'
import $ from 'jquery';
import { Range } from "../ui"
import AnimationUrl from './AnimationUrl.jsx'
import iconPen from '../ui/icons/icon_pen_new_white.svg'
import iconUpload from '../ui/icons/upload-img.png'
import iconGlobal from '../ui/icons/iconEarth.svg'
import iconLink from '../ui/icons/link-img.png'
import iconEmail from '../../../assets/images/email_icon.svg'
import iconDownload from '../../../assets/images/icon-download-white.svg'
import iconNote from '../../../assets/images/icon_note.png'
import iconQuestion from '../../../assets/images/question_mark_icon.svg'
import ReplyComment from './ReplyComment.jsx';
import { btnLoadTicketPage } from '../util/buildUrl';
import Select, { components } from "react-select";
import iconWeb from "../../../assets/images/type_web.png";
import iconLinkNew from "../../../assets/images/icon_link_new.png";


import { canUpdateAnimationMarker, canUpdateProject, canUseReplyFeature,
  canDeleteAnimation, canCreateAnimation, canCreateComment, canUpdateAnimation, canSwitchVersion, canReplyComment,
  canCreateCommentPublicUser, canUserNotPermission,
  canDownloadCSV, canUseUrlFeature, canUseZoomImageFeature, canHideCommentsFromCollaborators } from '../authorizations';
import { truncate } from '../util/truncate.js';

export default class AnimationMarkersPane extends Component {
  constructor(props) {
    super(props);
    const { currentAnimation } = props;
    this.state = {
      shouldShowAll: true,
      temp: false,
      heightAniamtion: 0,
      body: '',
      shouldShowUpdateMarker: false,
      shouldShowSelectTo: false,
      parentReplyId: null,
      userReply: null,
      sortComment: 'asc',
      // [2026-03-30] sort実装 開始
      tmSortMenuOpen: false,
      tmVerModalOpen: false,
      tmSortInfoModalOpen: false,
      tmShowAllModalOpen: false,
      // [2026-03-30] sort実装 終了
      hideFromExternal: false,
      tmSortAccOpen: false,
      tmTeamModalOpen: false,
      tmVerInfoModalOpen: false,
      isMarkerDisplayToCollaborators: currentAnimation?.additional_info['hide_marker_to_collaborators'] || false
    };

    this.hasTriggeredMarkerClickFromUrl = false;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }
  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
    // [2026-03-30] sort実装 開始
    document.removeEventListener('click', this._tmOutsideClickHandler, true);
    if (this._tmTouchStartHandler) {
      document.removeEventListener('touchstart', this._tmTouchStartHandler,
        { capture: true, passive: false });
    }
    if (this._tmTouchEndHandler) {
      document.removeEventListener('touchend', this._tmTouchEndHandler,
        { capture: true, passive: false });
    }
    // [2026-03-30] sort実装 終了
    const sortBody = document.getElementById('tm-sort-body');
    if (sortBody) sortBody.remove();
    const sortMenu = document.getElementById('tm-sort-menu');
    if (sortMenu) sortMenu.remove();
    const verModal = document.getElementById('tm-ver-modal');
    if (verModal) verModal.remove();
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);

    this.checkAndHighlightMarkerFromUrl();
    // [2026-03-30] sort実装 開始
    this._touchDevice = window.matchMedia('(pointer: coarse)').matches;
    window._tmSort = {
      order: this.state.sortComment,
      showAll: this.state.shouldShowAll,
      rebuild: () => { if (typeof window._tmRebuildAll === 'function') window._tmRebuildAll(); },
      isTimePage: () => this.isVideo()
    };
    this._tmOutsideClickHandler = (e) => {
      // 安全策: stateとDOMが不整合の場合はstateをリセットして何もしない
      var sortBodyEl = document.getElementById('tm-sort-body');
      if (this.state.tmSortAccOpen && (!sortBodyEl || sortBodyEl.style.display === 'none')) {
        this.setState({ tmSortAccOpen: false });
        return;
      }
      var insideSortUI = e.target && e.target.closest && (
        e.target.closest('#tm-sort-menu') ||
        e.target.closest('.change-sort-comemnt-akaire') ||
        e.target.closest('.tm-info-icon') ||
        e.target.closest('.tm-modal-body') ||
        e.target.closest('.tm-modal-backdrop') ||
        e.target.closest('#tm-sort-body') ||
        e.target.closest('#tm-sort-toggle') ||
        e.target.closest('#tm-ver-modal') ||
        e.target.closest('#tm-team-modal')
      );
      if (insideSortUI) return;
      // アコーディオンが開いている時は全外部クリックを遮断（DOM確認付き）
      if (this.state.tmSortAccOpen && sortBodyEl && sortBodyEl.style.display !== 'none') {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
      }
      this.setState({
        tmSortMenuOpen: false,
        tmVerModalOpen: false,
        tmSortInfoModalOpen: false,
        tmShowAllModalOpen: false,
        tmSortAccOpen: false,
        tmTeamModalOpen: false,
        tmVerInfoModalOpen: false,
      });
      var sortBody = document.getElementById('tm-sort-body');
      if (sortBody) sortBody.style.display = 'none';
      var sortMenu = document.getElementById('tm-sort-menu');
      var verModal = document.getElementById('tm-ver-modal');
      if (sortMenu) sortMenu.style.display = 'none';
      if (verModal) verModal.style.display = 'none';
    };
    document.addEventListener('click', this._tmOutsideClickHandler, true);

    // touchstart（iPad用・captureフェーズ）
    this._tmTouchStartHandler = function(e) {
      var sortBody = document.getElementById('tm-sort-body');
      var sortToggle = document.getElementById('tm-sort-toggle');
      if (!sortBody || sortBody.style.display === 'none') return;
      if (sortToggle && sortToggle.contains(e.target)) return;
      if (sortBody.contains(e.target)) return;
      var verModal = document.getElementById('tm-ver-modal');
      var sortMenu = document.getElementById('tm-sort-menu');
      if (verModal && verModal.contains(e.target)) return;
      if (sortMenu && sortMenu.contains(e.target)) return;
      // 外部タッチ → 全アクションを遮断
      e.stopPropagation();
      e.preventDefault();
    };
    document.addEventListener('touchstart', this._tmTouchStartHandler,
      { capture: true, passive: false });

    // touchend（iPad用・captureフェーズ）
    var self = this;
    this._tmTouchEndHandler = function(e) {
      var sortBody = document.getElementById('tm-sort-body');
      var sortToggle = document.getElementById('tm-sort-toggle');
      if (!sortBody || sortBody.style.display === 'none') return;
      if (sortToggle && sortToggle.contains(e.target)) return;
      if (sortBody.contains(e.target)) return;
      var verModal2 = document.getElementById('tm-ver-modal');
      var sortMenu2 = document.getElementById('tm-sort-menu');
      if (verModal2 && verModal2.contains(e.target)) return;
      if (sortMenu2 && sortMenu2.contains(e.target)) return;
      // 外部タッチ → 全アクションを遮断してアコーディオンを閉じる
      e.stopPropagation();
      e.preventDefault();
      sortBody.style.display = 'none';
      var verModalClose = document.getElementById('tm-ver-modal');
      var sortMenuClose = document.getElementById('tm-sort-menu');
      if (verModalClose) verModalClose.style.display = 'none';
      if (sortMenuClose) sortMenuClose.style.display = 'none';
      self.setState({
        tmSortAccOpen: false,
        tmSortMenuOpen: false,
        tmVerModalOpen: false,
        tmSortInfoModalOpen: false,
        tmShowAllModalOpen: false,
        tmTeamModalOpen: false,
        tmVerInfoModalOpen: false,
      });
    };
    document.addEventListener('touchend', this._tmTouchEndHandler,
      { capture: true, passive: false });

    // [2026-03-30] sort実装 終了
    // sort▽ アコーディオン本体を生成
    this._buildSortAccordion();
  }

  componentDidUpdate(prevProps, prevState) {
    const {heightAniamtion}=this.props
    if (!this.state.temp) {
      this.setState({ temp: true, heightAniamtion: heightAniamtion })
    }
    this.checkAndHighlightMarkerFromUrl();
    if (
      prevState && (
        prevState.sortComment !== this.state.sortComment ||
        prevState.shouldShowAll !== this.state.shouldShowAll ||
        prevState.hideFromExternal !== this.state.hideFromExternal ||
        prevState.isMarkerDisplayToCollaborators !== this.state.isMarkerDisplayToCollaborators
      )
    ) {
      this._updateSortToggleLabel();
      this._updateSortBodyLabels();
    }
    if (prevState && prevState.tmSortAccOpen !== this.state.tmSortAccOpen) {
      this._positionSortBody();
    }
    // バージョン変更後にアコーディオンを閉じてラベル更新
    if (prevProps && prevProps.animationSelectCurrent !== this.props.animationSelectCurrent) {
      this.setState({ tmVerModalOpen: false, tmSortAccOpen: false });
      var sortBody = document.getElementById('tm-sort-body');
      if (sortBody) sortBody.style.display = 'none';
      this._updateSortToggleLabel();
      this._updateSortBodyLabels();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.heightAniamtion !== this.state.heightAniamtion) {
      this.setState({ temp: false})
    }
    if (nextProps.markers !== this.props.markers) {
      this.setState({ parentReplyId: null, shouldShowSelectTo: false })
    }
    if (nextProps.currentAnimation !== this.props.currentAnimation) {
      this.setState({
        isMarkerDisplayToCollaborators: nextProps.currentAnimation?.additional_info['hide_marker_to_collaborators'] || false
      });
    }

    setTimeout(() => {
      this.checkAndHighlightMarkerFromUrl();
    }, 100);
  }

  checkAndHighlightMarkerFromUrl = () => {
    const url = new URL(window.location.href);
    const replyCommentIdFromUrl = url.searchParams.get('reply_comment_id');

    if (replyCommentIdFromUrl) {
      this.highlightReplyFromUrl(replyCommentIdFromUrl);
    } else {
      $(`.reply-comment-item[data-highlighted-from-url="true"]`).removeClass('highlight').removeData('highlighted-from-url');
    }
  }

  highlightReplyFromUrl = (replyCommentId) => {
    if (this.hasTriggeredMarkerClickFromUrl) return;
    if (isNaN(replyCommentId)) return;

    $(`.reply-comment-item`).removeClass('highlight').removeData('highlighted-from-url');

    setTimeout(() => {
      const replyElement = $(`#reply-comments-${replyCommentId}`);
      if (replyElement.length > 0) {
        replyElement.addClass('highlight').data('highlighted-from-url', true);

        replyElement.trigger('click');

        // Scroll to reply element
        const itemsContainer = replyElement.parents('.items');
        if (itemsContainer.length > 0) {
          itemsContainer.animate({
            scrollTop: replyElement.position().top + itemsContainer.scrollTop() - 100
          }, 'slow');
        }

        this.hasTriggeredMarkerClickFromUrl = true;
      }
    }, 300);
  }
  renderUnregisterUserTooltip() {
    return (
      <ReactTooltip id="marker-tooltip" place="top" effect="solid" delayHide={1000} type="light">
        <div className="text-danger font-weight-bold">
          権限がありません
        </div>
      </ReactTooltip>
    );
  }
  renderPromotionTooltip() {
    return (
      <ReactTooltip id="marker-tooltip" place="top" effect="solid" delayHide={1000} type="light">
        <div className="text-danger font-weight-bold">
          こちらは会員専用機能となります。
        </div>
        <div className="mt-2 mb-2">
          無料会員でも全機能が利用可！<br />
          保存期間も『無期限』
          <span className="small">※利用状況により3ヶ月間</span>
        </div>
        <a href="/signup" style={{ pointerEvents: 'initial' }} className="btn btn-warning" target="_blank">
          会員登録はこちら
        </a>
      </ReactTooltip>
    );
  }

  toggle (name, id = null, flagBool) {
    const commentMarker = this.markers().find(marker => marker.id === id)
    const body = commentMarker ? commentMarker.body : ''

    this.setState({ [`shouldShow${name}`]: flagBool, formMarkerId: id, body: body })
  }

  open(event, name, id) {
    event.stopPropagation();
    const {animationSelectCurrent, currentAnimationId} = this.props;
    if (animationSelectCurrent !== currentAnimationId) return

    this.toggle(name, id, true)
  }

  close(name, id) { this.toggle(name, id, false) }

  publicUserLogin(){
    const { currentUserId, owner, role: currentUserRole } = this.props;
    return !currentUserId && owner
  }
  puplicUserNotPermission(){
    const { currentUserId, owner, role: currentUserRole } = this.props;
    return currentUserId && !canCreateCommentPublicUser(currentUserRole) && owner
  }
  scrollToReply = id => {
    if ($('#reply-comments-' + id).length <= 0) return

    $('.items').animate({
      scrollTop: $('#reply-comments-' + id).position().top
    }, 'slow');
  }
  onClickUpdate(values, targetId, marker) {
    let scrollTopPosition = this.fetchPositionComment(targetId);
    const { currentUserId, owner, role: currentUserRole, animationSelectCurrent, currentAnimationId } = this.props;
    var _isPublicShareUrl = (typeof gon !== 'undefined' && gon.is_public_share_url);
    if (((this.publicUserLogin() || this.puplicUserNotPermission()) && !_isPublicShareUrl) || animationSelectCurrent !== currentAnimationId) {
      return
    }
    return event => {
      event.preventDefault();
      event.stopPropagation();
      const { onMarkerUpdationCalled } = this.props;
      onMarkerUpdationCalled(values, targetId);
      this.keepPositionComment(targetId, scrollTopPosition)
      this.openCommentDetail(marker)
    }
  }
  onClickMarker(id) {
    return () => {
      const { onClickMarker } = this.props;
      onClickMarker(id);
    };
  }
  onChangeBody = ({ target: { value: value }}) => {
    this.setState({body: value})
  }

  onSubmitUpdateMarker = (event) => {
    const { apiClient, reloadMarkers } = this.props;
    const { body, formMarkerId } = this.state;
    let scrollTopPosition = this.fetchPositionComment(formMarkerId);
    const keepPosition = this.keepPositionComment(formMarkerId, scrollTopPosition)
    const commentMarker = this.markers().find(marker => marker.id === formMarkerId)
    const { animation_id, id } = commentMarker;
    const data = objectToFormdata({ animation_marker: { body: body } })

    event.preventDefault();
    this.setState({ isSubmitting: true })

    return apiClient.patch(`animations/${animation_id}/animation_markers/${id}`, data)
      .then(_ => {
        this.setState({ isSubmitting: false, formMarkerId: null, shouldShowUpdateMarker: false })
        reloadMarkers();
        setTimeout(function() {
          keepPosition
        }, 600)
      })
      .catch(_ => {
        this.setState({ isSubmitting: false, formMarkerId: null })
        toast.error('コメントの投稿に失敗しました。');
      })
  }
  showHeight() {
    const { heightAniamtion, mobile } = this.props;
    if(mobile)
      return
    const height = findDOMNode(this.image).getBoundingClientRect().height;
    const heightMarker = heightAniamtion - height - 60;
    if (heightAniamtion < 940 && heightMarker != 0)
      return heightMarker < 0 ? 270 : heightMarker
    let size = window.innerWidth;
    let x = 410;
    switch (true){
      case (size < 717):
        break;
      case (size < 926):
        x = 'auto'
        break;
      case (size < 1025):
        x = 320;
        break;
      case (size < 1026):
        x = 'auto'
        break;
      case (size < 1253):
        x = 300;
    }
    return x
  }
  mountEnter =(event, id) =>{
    this.hover_in_player(id, '#DBDBDB', 'rgba(253, 239, 135, 0.4)', 'block');
  }
  mountLeave=(event, id)=> {
    this.hover_in_player(id, 'unset', 'rgba(255, 239, 135, 0.2)', 'none');
  }
  onClick =(event, id, marker)=>{
    const { onClickMarker } = this.props;
    onClickMarker(id);
    setTimeout(() => {
      if ($('.marker-' + id).length > 0) {
        $('.wrap-animation-preview').animate({
          scrollTop: $('.marker-' + id).position().top - 200
        }, 'slow');
      }
      this.openCommentDetail(marker)
      $('.animation-marker').removeClass('highlight');
      $('.animation-marker-' + id).addClass('highlight');
      // [2026-05-11] markerNo赤点滅
      const blinkEl = document.querySelector(`.show-mark-shape.marker-${id}`);
      if (blinkEl) {
        blinkEl.classList.remove('tm-marker-blink');
        void blinkEl.offsetWidth;
        blinkEl.classList.add('tm-marker-blink');
        setTimeout(() => blinkEl.classList.remove('tm-marker-blink'), 2100);
      }
      $('#show-period').val(false);
      if ($('.remove-pd').length > 0) $('.remove-pd').find('.widget_close_wrapper').trigger('click');
    }, (marker.animationPdfPageId ? 300 : 0))
  }

  openCommentDetail = (marker) => {
    this.props.updateSelectedMarker(marker);
  }

  fetchPositionComment = (id) => {
    let scrollTopPosition = 0;
    if ($(`.animation-marker-${id}`).length > 0) {
      const divScroll = $(`.animation-marker-${id}`).parents('.items')[0];
      scrollTopPosition = divScroll.scrollTop;
    }
    return scrollTopPosition
  }

  keepPositionComment = (id, scrollTopPosition) => {
    if (scrollTopPosition !== 0) {
      $(`.animation-marker-${id}`).parents('.items').animate({
        scrollTop: scrollTopPosition
      }, 'slow');
    }
  }

  hover_in_player(marker, background_animation, background_maker, display) {
    var menus = document.querySelector('.animation-marker-' + marker);
    menus.style.backgroundColor = background_animation;
    var markers = document.querySelector('.marker-' + marker);
    if(markers == null)
      return
    var child = markers.querySelector('.red-rect') || markers.querySelector('.red-point');
    var card = markers.parentNode.querySelector('.card');

    if(child) {
      child.style.backgroundColor = background_maker;
    }
    if(card) {
      card.style.display = display;
    }
  }

  usersToInReplyComment = (replyIds, assignments) => {
    return assignments.filter(assignment => replyIds.includes(`${assignment.value}`))
                      .map(assignment => truncate(assignment.label, 10))
  }

  toggleSelectTo = (isShow) => {
    this.setState({shouldShowSelectTo: isShow})
  }

  wasSeeReply = (replyId) => {
    const { neverSeenReplyIds } = this.props;
    return neverSeenReplyIds && !neverSeenReplyIds.includes(replyId)
  }

  memberIdsInComment() {
    const { membersInComment } = this.props;
    return membersInComment.map(({ _label, value }) => value)
  }

  markersSection(markers = []) {
    const {
      currentUserId, apiClient, role, shouldShowAd, mobile,
      assignments, reloadMarkers, isStillAvailableStorage,
      deleteReplyMarker, taskId, currentTicketId, rootUrl, port, env, membersInComment
    } = this.props;
    const { parentReplyId, shouldShowSelectTo, userReply, sortComment } = this.state;
    return (
      <ResizableWithControls
        className={ mobile && !this.isVideo() ? 'mobile-sp-image-list-comment' : 'image-list-comment' }
        defaultHeight={ mobile ? this.isVideo() ? 225 : 270 : (typeof navigator !== 'undefined' && (/iPad/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))) ? 498 : 600 }
        wrapperClass = {this.isVideo() ? 'items for-video-list-items' : 'items for-image-list-items'}
        isMobile={mobile}
        enable={{ top: false, right: false, bottom: true, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }} >
          <input type="hidden" id="show-period" value="false" />
          <div className='items-animate'>
            {
              markers.sort((a, b) => { return this.isVideo() ? sortComment === 'asc' ? a.seek_time - b.seek_time || b.id - a.id : b.seek_time - a.seek_time || a.id - b.id : sortComment === 'asc' ? a.number_comment - b.number_comment : b.number_comment - a.number_comment }).map(({ seek_time: time, period_end: periodEnd, body, id, number_comment, status, user, animation_marker_files: files, reply_comments: replyComments, created_at, border_color, animation_id, email_temp, user_name_temp, animation_pdf_page_id }, i) => {
                const marker = {
                  body: body,
                  time: time,
                  periodEnd: periodEnd,
                  isVideo: this.isVideo(),
                  status: status,
                  id: id,
                  border_color: border_color,
                  index: number_comment,
                  user: user,
                  created_at: created_at,
                  isComment: true,
                  animation_id: animation_id,
                  files: files,
                  receivers: membersInComment,
                  userReply: user,
                  email_temp: email_temp,
                  animationPdfPageId: animation_pdf_page_id,
                  user_name_temp, user_name_temp
                }
                const user_temp = user_name_temp ? user_name_temp : null

                return (
                  <div key={i}>
                    <div className={`item-akapon px-2 py-1 d-flex animation-marker animation-marker-${id}`}
                         onClick={(event)=>this.onClick(
                           event,
                           id,
                           marker
                         )}
                         data={id}
                         onMouseEnter={(event) => { this.mountEnter(event, id) }}
                         onMouseLeave={(event) => { this.mountLeave(event, id) }}
                    >
                      <div className={`status-field ${!canCreateCommentPublicUser(role) && ('disabled') }`}>
                        {
                          canUpdateAnimationMarker(role) && (
                            status === 'initial' ? (
                              <div data-tip data-for="marker-tooltip">
                                <CardLink onClick={this.onClickUpdate({ status: 'completed' }, id, Object.assign({}, marker, { status: 'completed' }))} href="#" >
                                  <span className="far fa-circle status-circle"></span>
                                </CardLink>
                              </div>
                            ) : (
                              <div data-tip data-for="marker-tooltip">
                                <CardLink onClick={this.onClickUpdate({ status: 'initial' }, id, Object.assign({}, marker, { status: 'initial' }))} href="#">
                                  <span className="far fa-check-circle status-circle status--completed"></span>
                                </CardLink>
                              </div>
                            )
                          )
                        }
                      </div>
                      <div className='comment-container'>
                        <div className="comment-info d-flex justify-content-between">
                          <div className={`d-inline-block author-name text-ellipsis ${periodEnd ? 'truncate-name-has-period' : 'truncate-name-not-period'}`} style={{marginRight: '8px'}}>{user && user.name_in_project || user_temp || '（非ログイン）'}{user && user.deleted_at ? '（解約済み）' : ''}</div>
                          {!user && email_temp && (
                            <div className="tm-not-login-email" style={{fontSize: '11px', color: '#aaa', marginTop: '2px'}}>{email_temp}</div>
                          )}
                          {
                            periodEnd ? (
                              <div className='d-inline create-at' style={{float: 'right'}}>{moment.utc(time * 1000).format("HH:mm:ss.S")} ~ {moment.utc(periodEnd * 1000).format("HH:mm:ss.S")}</div>
                              ) : (
                              <div className='d-inline create-at'>{moment(created_at).format('YYYY/MM/DD HH:mm:ss', 'Asia/Tokyo')}</div>
                            )
                          }
                        </div>
                        <div className="comment-content">
                          <div className="body message truncate line-clamp-1 safe-html-akaire" dangerouslySetInnerHTML={{__html: (body || '').replace(/<img[^>]*>/gi, '') }}></div>
                        </div>
                      </div>

                      <div className='border-none numerical-order-container d-flex justify-content-center align-items-center' style = {{backgroundColor: border_color }}>
                        <div className="comment-no">
                          {number_comment}
                        </div>
                      </div>
                    </div>
                    {
                      assignments && replyComments && replyComments.map((comment, index) => {
                        return <ReplyComment userReply={comment.user} user={comment.user} id={comment.id} deleteReplyMarker={deleteReplyMarker} assignments={membersInComment} replyComment={comment} reloadMarkers={reloadMarkers} currentUserId={currentUserId} disabledReply={false} shouldShowReplyButton={true} seen={this.wasSeeReply(comment.id)}
                        reply={this.openReplyForm}
                        positionComment={this.fetchPositionComment}
                        keepPositionComment={this.keepPositionComment}
                        updateSelectedMarker={this.props.updateSelectedMarker}
                        receivers={membersInComment} parentsComment={body} parentUser={user} parentCreatedAt={created_at} parentUserNameTemp={user_temp}
                        key={comment.id} onClickMarker={this.props.onClickMarker}
                        />
                      })
                    }
                  </div>
                );
              })
            }
          </div>
      </ResizableWithControls>
    );
  }

  currentVersion = () => {
    const {animations, currentAnimationId} = this.props;
    return (animations && animations.filter(animation => animation.id == currentAnimationId)[0]?.title)
  }

  currentPage = () => {
    const {pages, currentPageId} = this.props;
    return (pages && pages.filter(page => page.id == currentPageId)[0]?.title)
  }

  ticketsSection(){
    const {tickets, currentTicketId, onChangeTicket, role, project} = this.props
    return (
      <Input type="select" onChange={onChangeTicket} value={currentTicketId} disabled={canUserNotPermission(role)} style={{maxWidth: "372px"}}>
        { <option value='task' token={project && project.url_token}>タスク管理</option> }
        {
          tickets.map((ticket) => {
            return (
              <option value={ticket[0]} token={ticket[2]}>
                {ticket[1]}
              </option>
            );
          })
        }
      </Input>
    )
  }
  imageButton(){
    const { role, animations, currentAnimation, getUrlModal, completionModal, publicUrlModal, onClickShareButton } = this.props;
    return (
      <div className="control-button-bottom d-none">
        <div className="btn-url button" data-tip data-for="sign-up-promotion-tooltip">
          <Button className="button-url" disabled={!canCreateAnimation(role, animations)} onClick={getUrlModal}>
            <img src={iconGlobal} />
            <p className='white-p break-work-button'>URL入力</p>
          </Button>
        </div>
        {
          currentAnimation ? (
            <div className="btn-share-url button" data-tip data-for="sign-up-promotion-tooltip">
              <Button className="button-completion" onClick={onClickShareButton} disabled={canUserNotPermission(role)}>
                <img src={iconLink} />
                <p className='white-p break-work-button'>赤入れ共有URL</p>
              </Button>
            </div>
          ) : (
            <></>
          )
        }
      </div>
    )
  }

  videoButton(){
    const {
      role, animations, currentAnimation, completionModal, publicUrlModal, getUrlModal, onClickShareButton, disabled,
      getUrlYoutube
    } = this.props;
    return(
      <div className="control-button-bottom d-none">
        <div className="btn-url button" data-tip data-for="sign-up-promotion-tooltip">
          <Button className="button-url" disabled={!canCreateAnimation(role, animations)} onClick={getUrlYoutube}>
            <img src={iconGlobal} />
            <p className='white-p break-work-button'>URL入力</p>
          </Button>
        </div>

        {
          currentAnimation ? (
            <div className="btn-url btn-share-url button" data-tip data-for="sign-up-promotion-tooltip">
              <Button onClick={onClickShareButton} disabled={canUserNotPermission(role)}>
                <img src={iconLink} />
                <p className='white-p break-work-button'>赤入れ共有URL</p>
              </Button>
            </div>
          ) : (
            <></>
          )
        }
      </div>
    )
  }
  showMarker(){
    const { markers } = this.props
    return typeof markers != "undefined" && markers.length === 0
  }
  showExtension(){
    const { changeExtension, selectAnimationExtension, role, animations, extensions}=this.props
    const { currentAnimation } = this.props;
    if (typeof extensions != "undefined" && this.isVideo() && currentAnimation && !currentAnimation.is_video_embed) {
      return (''
      )
    }
  }
  showAnimation(text){
    const { animations, currentAnimationId, onChange, disabled, role, currentAnimation, scaleImage, onChangeScaleImage,
            currentSubscriptionType,currentUserRole, isShowDrawComponent }=this.props
    var versionSelector = "version-selector pb-0 pt-0 text-left mb-3"
    if(!this.isVideo()){
      versionSelector = versionSelector.concat(" version-selector-image")
    }
    const classWithVideo = this.fetchClassWithVideoEmbed()
    const currentUrlFile = currentAnimation?.file_object?.url?.split('?')[0]?.split('.')
    const isGdriveFile  = currentAnimation?.additional_info?.gdrive_image
    const extensionFile = currentAnimation && !currentAnimation.is_video_embed && !isGdriveFile &&
                            currentUrlFile[currentUrlFile.length -1]?.toUpperCase();
    if (typeof animations != "undefined") {
      return currentAnimation && !currentAnimation.is_video_embed ? (
        <div className={versionSelector} data-tip data-for="sign-up-promotion-tooltip">
        </div>
      ) : currentAnimation && this.isVideo() && canUseZoomImageFeature(currentUserRole,currentSubscriptionType) &&
          currentAnimation.is_video_embed ? (
        <div className='d-flex video-embed-youtube flex-wrap'>
        <div className={"zoom-of-video-youtube " + versionSelector} data-tip data-for="sign-up-promotion-tooltip">
        </div>
          <Range
            containerClass={"ml-3"}
            className={classWithVideo + " ml-1 col-6"}
            value={scaleImage}
            step={5}
            handleChange={onChangeScaleImage}
            isShowDrawComponent={isShowDrawComponent}
          />
        </div>
      ) : ''
    }
  }
  showDownloadImage(text){
    const { disabled, downloadUrl, onClickDownloadImageButton } = this.props;
    return(
      <div className="item-akapon modal-download-animation " disabled={disabled}>
        <Button className="btn-download-video" onClick={() => onClickDownloadImageButton(downloadUrl, !disabled)} download disabled={disabled}>
          <p>
            {text}Download
          </p>
          <span className="app-icon icon-download"></span>
        </Button>
      </div>
    )
  }
  showDownloadVideo(text){
    const { disabled, downloadUrl, onClickDownloadButton, is_video_embed } = this.props;
    return (
      <div className="item-akapon modal-download-animation " disabled={disabled}>
        <Button className="btn-download-video" onClick={onClickDownloadButton} disabled={disabled}>
          <p>
            {text}Download
          </p>
          <span className="app-icon icon-download"></span>
        </Button>
      </div>
    )
  }
  downloadCSV = () => {
    const { currentAnimationId, projectId, taskId, currentTicketId } = this.props;
    const animationType = this.isVideo() ? 'video' : 'image'
    let url = `/akaire_feature/akaire_files/${taskId}/animations/${currentAnimationId}/animation_markers.csv?project_type=${animationType}`;
    window.open(url, '_blank');
  }

  showDownloadCSV() {
    const { disabled } = this.props;
    return (
      <div className="item-akapon">
        <Button className="btn-download-csv" onClick={this.downloadCSV} style={{whiteSpace: 'normal'}} disabled={disabled}>
          <span>
            <p>コメントDownload</p>
          </span>
          <span className="app-icon icon-download"></span>
        </Button>
      </div>)
  }
  changeSortComment = (value) => {
    this.setState({ sortComment: value });
    // [2026-03-30] sort実装 開始
    if (window._tmSort) window._tmSort.order = value;
    // [2026-03-30] sort実装 終了
  }

  showPage = () => {
    const { pages, onChangePage, currentPageId, onSubmit, role, deletePage, currentAnimation, onClickFinalizeAnimation,
            onClickCancelFinalAnimation, animations, page_last_animation } = this.props;
    return (
      <AnimationPages currentAnimation={currentAnimation} onClickFinalizeAnimation={onClickFinalizeAnimation} onClickCancelFinalAnimation={onClickCancelFinalAnimation} pages={pages} onChangePage={onChangePage} currentPageId={currentPageId} onSubmit={onSubmit} role={role} deletePage={deletePage} animations={animations} page_last_animation={page_last_animation}/>
    )
  }

  openPlanHeaderModal = () => {
    const toggleBtn = $('#plan-header-toggle-btn');
    if(toggleBtn && toggleBtn.length > 0) {
      toggleBtn.trigger('click');
    }
    else {
      window.open(Routes.owner_total_info_path(), '_blank');
    }
  }
  showPopupShareUrl = () => {
    const { is_free_plan, uploadedDataInfo } = this.props;
    const plan_name = uploadedDataInfo.currentPlanName;
    if (is_free_plan) {
      Popup.confirm(
        `チームアカウントがLightプラン以上をご契約の場合に<br>ご利用いただけます。<br>現在のアカウントは「${plan_name}プラン」のため、<br>本機能はご利用いただけません。`,
        {
          success: () => {
            this.openPlanHeaderModal();
          },
          cancel: () => {},
          confirmText: 'プラン変更',
          cancelText: 'キャンセル',
          width: 'auto',
        }
      )
    } else {
      $('.btn-share-url button').click();
    }
  }

  showControlAnimation = (text) => {
    const { role,uploadAnimation, autoComment, owner, animations, scaleImage, onChangeScaleImage,
            isDisabledButtonSendMailNotLogin, showPopupConfirmSendMailNotLogin, isShowDrawComponent, currentAnimation } = this.props;
    const classWithVideo = this.fetchClassWithVideoEmbed()
    if (currentAnimation == undefined) {
      const event = new CustomEvent('AkaireDownloadModalUnLoaded');
      document.dispatchEvent(event);
    } else {
      const event = new CustomEvent('AkaireDownloadModalLoaded');
      document.dispatchEvent(event);
    }
    return (
      <div className="control-down">
        {/* <div className='mb-2 text-light'>アクションツール</div> */}
        <div className="control-button" data-tip data-for="sign-up-promotion-tooltip">
          <div className="control-button-top flex-wrap">
            {
              (!canCreateComment(role) || this.publicUserLogin() || this.puplicUserNotPermission() || !gon.is_login) && role !== 'reader' ? (
                <div className="btn-donwload button" data-tip data-for="sign-up-promotion-tooltip">
                  <Button disabled={isDisabledButtonSendMailNotLogin || isShowDrawComponent || currentAnimation?.need_conversion} onClick={() => {
                    if (!gon.is_login) {
                      const emailTemp = localStorage.getItem('email_temp_of_not_login');
                      const userTemp = localStorage.getItem('user_temp_of_not_login');
                      if (!emailTemp || !userTemp) {
                        if (window._tmOpenNotLoginModal) window._tmOpenNotLoginModal();
                        return;
                      }
                    }
                    showPopupConfirmSendMailNotLogin();
                  }} className="button-auto-comment">
                    <img src={iconEmail} style={{transform: 'scale(1.6)'}} />
                    <p className='white-p break-work-button btn-small-mb'>赤入れ通知</p>
                    <span class="ap-detail-show-popup-comment"
                      onClick={this.showPopupAkaireNotificationTooltip}
                    >？</span>
                  </Button>
                </div>
              ) : (
                <>
                  <div className="btn-donwload button mb-2" data-tip data-for="sign-up-promotion-tooltip">
                    <Button disabled={currentAnimation?.need_conversion} onClick={isShowDrawComponent ? null : autoComment} className="button-auto-comment">
                      <img src={iconEmail} style={{transform: 'scale(1.6)'}} />
                      <p className='white-p break-work-button btn-small-mb'>赤入れ通知</p>
                      <span className="ap-detail-show-popup-comment"
                        onClick={this.showPopupAkaireNotificationTooltip}
                      >？</span>
                    </Button>
                    { currentAnimation && currentAnimation.is_pdf ? (
                        <Button onClick={this.showPopupShareUrl} className="button-auto-comment btn-share-url">
                        <img className="filter-to-white" src={iconLinkNew} style={{transform: 'scale(1)'}} />
                        <p className='white-p break-work-button btn-small-mb'> 赤入れ共有URL</p>
                        <span className="ap-detail-show-popup-comment"
                          onClick={this.showPopupShareUrlTooltip}
                        >？</span>
                      </Button>
                    ) : (
                      <Button className="button-download" disabled={currentAnimation==undefined} onClick={(event) => {
                        setTimeout(function() {
                          SideBar.showModalDownloadAnimation(this);
                          event.stopPropagation()
                        }, 100);
                          }}
                          >
                        <img src={iconDownload} style={{transform: 'scale(1.6)'}} />
                        <p className='white-p break-work-button btn-small-mb'>ダウンロード</p>
                      </Button>
                    )}
                  </div>
                  <div className="btn-donwload button btn-url mb-2" data-tip data-for="sign-up-promotion-tooltip">
                    {currentAnimation && !currentAnimation.is_pdf && (
                        <Button onClick={this.showPopupShareUrl} className="button-auto-comment btn-share-url">
                        <img className="filter-to-white" src={iconLinkNew} style={{transform: 'scale(1)'}} />
                        <p className='white-p break-work-button btn-small-mb'> 赤入れ共有URL</p>
                        <span className="ap-detail-show-popup-comment"
                          onClick={this.showPopupShareUrlTooltip}
                        >？</span>
                      </Button>
                    )}
                    {this.isVideo() && (
                      <Button onClick={() => { if (window._tmOpenPublicUrlModal) { window._tmOpenPublicUrlModal(); } else { openPublicUrlPopup(); } }} className="button-auto-comment btn-share-url">
                        <img className="filter-to-white" src={iconWeb} style={{transform: 'scale(1)', width: '24px'}} />
                        <p className='white-p break-work-button btn-small-mb'>動画視聴用URL</p>
                        <span className="ap-detail-show-popup-comment"
                          onClick={this.showPopupShareUrlVideoTooltip}
                        >？</span>
                      </Button>
                    )}
                  </div>
                  <div className="btn-donwload button mb-2 btn-url" data-tip data-for="sign-up-promotion-tooltip">
                    <Button onClick={() => AkaireFile.openUploadVersionModal()} className="button-auto-comment btn-share-url">
                      <img src={iconUpload} style={{transform: 'scale(1.6)'}} />
                      <p className='white-p break-work-button btn-small-mb'>バージョン更新</p>
                    </Button>
                    <Button className="button-auto-comment btn-share-url" onClick={() => AkaireFile.openUploadNewPageModal()}>
                      <img src={iconNote} style={{transform: 'scale(1.4)'}} />
                      <p className='white-p break-work-button btn-small-mb'>ページ追加</p>
                    </Button>
                  </div>
                </>
              )
            }
          </div>
          {this.isVideo() ? this.videoButton() : this.imageButton()}
          <div id="slider-scale-box" className="container-scale-box">
            <p className="title-scale-line">拡大縮小</p>
            <div className='slider-scale-box' style={{position: "relative"}}>
              <Range
                containerClass={"ml-3"}
                className={classWithVideo + " ml-1 col-6"}
                value={scaleImage}
                step={5}
                handleChange={onChangeScaleImage}
                isShowDrawComponent={isShowDrawComponent}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
  showControlVersion = (text) => {
    const { role, deleteAnimation, currentSubscriptionType } = this.props;
    return (
      <div className="animation-buttons new--asdasd-a-sd">

        {this.isVideo() ? this.showDownloadVideo(text) : this.showDownloadImage(text)}
        {canDownloadCSV(currentSubscriptionType) ? this.showDownloadCSV() : ''}
        <div className="item-akapon" data-tip data-for="sign-up-promotion-tooltip">
          <Button className="btn-delete-animation" onClick={deleteAnimation} disabled={!canDeleteAnimation(role)} >
            <span className="u-fontColor--red">
              <p>バージョン削除</p>
            </span>
            <span style={{fontSize: '14px'}} className="fas fa-trash-alt"></span>
          </Button>
        </div>
      </div>
    )
  }
  fetchClassWithVideoEmbed() {
    return 'col-12 text-right'
  }

  showMarkerButton(text){
    const { animations, canUsePageManagement, currentAnimation,onMode,onChangeMode, scaleImage, onChangeScaleImage,
            mobile, currentSubscriptionType,currentUserRole, isShowDrawComponent } = this.props;
    const classWithVideo = this.fetchClassWithVideoEmbed()
    return (
      <div className="d-none">
        <hr style={{ border: this.props.isAkaponMember ? 'none' : '' }} />
        <div className="">
          <div className="version">
            {/* { canUsePageManagement ? this.showPage() : ''} */}
            {
              canUseUrlFeature(currentUserRole,currentSubscriptionType) && currentAnimation && currentAnimation.url &&
              <AnimationUrl currentAnimationUrl={currentAnimation.url} isMobile={mobile}/>
            }

            <div style={{display: 'flex', justifyContent: 'space-between'}} className={`version-top ${this.isVideo() ? "video" : ''} row ml-0 mr-0`}>
              { animations && animations.length > 0 ? this.showAnimation(text) : '' }
              { animations && animations.length > 0 ? this.showExtension() : '' }
              { currentAnimation && !currentAnimation.is_video_embed &&
                canUseZoomImageFeature(currentUserRole,currentSubscriptionType) &&
                <Range
                containerClass={"ml-3"}
                className='col-6 mb-0 text-right mb-3'
                value={scaleImage}
                step={5}
                handleChange={onChangeScaleImage}
                isShowDrawComponent={isShowDrawComponent}
              />}
            </div>
            { animations && animations.length > 0 ? this.showControlVersion(text) : '' }
          </div>
        </div>
      </div>
    )
  }
  isVideo(){
    const { project_type } = this.props;
    return ['動画', 'video'].includes(project_type)
  }
  truncateName(name){
    let size = window.innerWidth;
    if (typeof name != "undefined") {
      switch(true){
        case(size < 1025):
          return name.length > 12 ? name.substring(0, 10) + "..." : name;
        case(size < 1300):
          return name.length > 15 ? name.substring(0, 14) + "..." : name;
      }
      return name.length > 30 ? name.substring(0, 20) + "..." : name;
    }
  }
  markersForm(){
    const {
      role, projectFormModal, name, currentUserId, currentAnimation,
      currentPageId, canUsePageManagement, currentAnimationTotalSize,
      tickets, currentTicketId, rootUrl, port, taskId, projectId, env, animations, isAkaponMember
    } = this.props;
    var text = "画像";

    if (this.isVideo()){
      text = "動画";
    }
    var ticketsSection = this.ticketsSection();
    return (
      <div className='marker-button top-pane' ref={ref => this.image = ref}>
        {/* Dont display it anymore */}
        {/* {!currentUserId && this.renderPromotionTooltip()} */}
        {/* <div className="animation-file-size">
          <div className="dt position-text-top-1">
            {isAkaponMember ? '赤入れ名：' : 'タスク名：'}
            <span className='text-light text-truncate position-text-top'>
              { name }
            </span>
          </div>
          <div className="dt">
            ファイル容量：
            <span className='text-light'>
              {bytes(currentAnimationTotalSize)}
            </span>
          </div>
        </div> */}
        {/* <div className="markerpane-control"> */}
          {/* <hr /> */}
          {/* <div className='mb-2 text-light'>セレクトツール</div> */}
          {/* <div className="control-box">
            {
              (!currentUserId || !isAkaponMember) &&
              <div className="ticket-name">
                <p>
                  赤入れ保存場所&nbsp;&nbsp;&nbsp;
                  {
                    currentTicketId != 'task' &&
                    <a href={canUserNotPermission(role) ? 'javascript:void(0)' : btnLoadTicketPage(env, rootUrl, port, currentTicketId != 'task', projectId, taskId, currentTicketId)}
                      className="link-load-ticket-page">(このページに移動)
                    </a>
                  }
                </p>
                { ticketsSection }
              </div>
            }

            {currentPageId && canUsePageManagement || !canUsePageManagement ? this.showMarkerButton(text) : ""}
          </div> */}
          {currentPageId && canUsePageManagement || !canUsePageManagement ? this.showMarkerButton(text) : ""}
          { animations && animations.length > 0 ? this.showControlAnimation(text) : ''}
        {/* </div> */}
      </div>
    )
  }
  markers() {
    const { shouldShowAll } = this.state;
    const { markers } = this.props;
    return shouldShowAll ? markers : markers.filter(_ => _.status === 'initial');
  }
  onChangeCheck = ({ target: { checked } }) => {
    this.setState({ shouldShowAll: checked });
    // [2026-03-30] _tmSort.showAll同期
    if (window._tmSort) {
      window._tmSort.showAll = checked;
      window._tmSort.rebuild();
    }
  }

  showPopupAkaireNotificationTooltip = (e) => {
    e.stopPropagation();
    Popup.alert(
      'コメント作成後、メンバーへ赤入れ通知はされません。<br>' +
      'メンバーへ赤入れ通知を行う場合は「赤入れ通知」または各コメント「更新」ボタンをクリックすると通知されます。<br>' +
      '※コメント単位の返信については、都度、メンバーへ送信されます。',
      '', '', {kind: 'akaire'}
    );
  }

  showPopupShareUrlTooltip = (e) => {
    e.stopPropagation();
    $('#sidebar-recently').toggleClass('d-none');
    Popup.alert(
      '・赤入れ共有URLを付与されたメンバーは、ログイン状況に関わらず、<br>' +
      '　「このファイルの全ページの最新バージョン」の赤入れ履歴（コメント）を閲覧できます。<br><br>' +
      '・URLのパスワード設定は、有料プランのみご利用いただけます。',
      '', '', {kind: 'akaire'}
    );
  }

  showPopupShareUrlVideoTooltip = (e) => {
    e.stopPropagation();
    $('#sidebar-recently').toggleClass('d-none');
    Popup.alert(
      '・表示中のページおよびバージョンの動画視聴用URLを発行します。<br>' +
      '・非ログインメンバーには赤入れ履歴（コメント）は表示されません。<br>' +
      '・URLのパスワード設定は、有料プランのみご利用いただけます。',
      '', '', {kind: 'akaire'}
    );
  }

  // [2026-03-30] sort実装 開始
  _isTouchDevice() { return this._touchDevice || false; }

  _getSortLabel() {
    const { sortComment } = this.state;
    if (this.isVideo()) {
      return sortComment === 'asc' ? '尺順（先頭から）▼' : '尺順（後ろから）▼';
    }
    return sortComment === 'asc' ? '古い順（No 昇順）▼' : '新しい順（No 降順）▼';
  }

  _getSortItems() {
    if (this.isVideo()) {
      return [
        { value: 'asc',  label: '▲ 尺順（先頭から）' },
        { value: 'desc', label: '▼ 尺順（後ろから）' }
      ];
    }
    return [
      { value: 'asc',  label: '▲ 古い順（No 昇順）' },
      { value: 'desc', label: '▼ 新しい順（No 降順）' }
    ];
  }

  _handleTmSortChange(value) {
    this.changeSortComment(value);
    this.setState({ tmSortMenuOpen: false, tmSortAccOpen: false });
    if (window._tmSort) {
      window._tmSort.order = value;
      window._tmSort.rebuild();
    }
    var body = document.getElementById('tm-sort-body');
    if (body) body.style.display = 'none';
    this._updateSortToggleLabel();
    this._updateSortBodyLabels();
  }

  _getSortShortLabel() {
    const label = this._getSortLabel();
    if (!label) return 'ソート';
    if (label.includes('先頭')) return '先頭順';
    if (label.includes('後ろ')) return '末尾順';
    if (label.includes('古い')) return '古い順';
    if (label.includes('新し')) return '新しい順';
    return label.slice(0, 5);
  }

  _getSortToggleLabel() {
    const { animations, role, animationSelectCurrent, currentAnimationId } = this.props;
    const { shouldShowAll, isMarkerDisplayToCollaborators } = this.state;

    const effectiveId = animationSelectCurrent || currentAnimationId;
    const animation = animations && animations.find(
      a => String(a.id) === String(effectiveId)
    );
    const verLabel = animation
      ? (animation.final ? '最終稿' : (animation.title || String(effectiveId)))
      : '最終稿';

    const sortLabel = this._getSortShortLabel();
    const showAllLabel = shouldShowAll ? '全表示' : '✓以外';

    const isInternal = typeof canHideCommentsFromCollaborators === 'function'
      ? canHideCommentsFromCollaborators(role)
      : false;
    const hideLabel = isInternal
      ? (isMarkerDisplayToCollaborators ? '外部除外' : '全員')
      : null;

    const parts = [verLabel, sortLabel, showAllLabel, hideLabel].filter(Boolean);
    return '\u3010 \u30B3\u30E1\u30F3\u30C8\u30C4\u30FC\u30EB \u3011' + parts.join(' \u00B7 ');
  }

  _positionSortBody() {
    const toggle = document.getElementById('tm-sort-toggle');
    const body = document.getElementById('tm-sort-body');
    if (!toggle || !body) return;
    const rect = toggle.getBoundingClientRect();
    body.style.top = (rect.bottom + 4) + 'px';
    body.style.left = rect.left + 'px';
    body.style.minWidth = rect.width + 'px';
    body.style.display = this.state.tmSortAccOpen ? 'block' : 'none';
  }

  _buildSortAccordion() {
    const { role } = this.props;
    const isInternal = typeof canHideCommentsFromCollaborators === 'function'
      ? canHideCommentsFromCollaborators(role)
      : false;
    const _isIPad = typeof navigator !== 'undefined' && (
      /iPad/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );

    const existing = document.getElementById('tm-sort-body');
    if (existing) existing.remove();

    const body = document.createElement('div');
    body.id = 'tm-sort-body';
    body.style.display = 'none';

    const self = this;

    function addTap(el, handler) {
      el.addEventListener('click', handler);
      if (_isIPad) {
        el.addEventListener('touchend', function(e) {
          e.preventDefault();
          handler(e);
        });
      }
    }

    // チェックボックス要素を生成するヘルパー
    function makeCheckbox(id, checked) {
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.id = id;
      cb.checked = !!checked;
      cb.className = 'tm-sort-checkbox';
      return cb;
    }

    // --- 項目1: バージョン ---
    var item1 = document.createElement('div');
    item1.className = 'tm-sort-item';
    // 現在のバージョン名を取得
    var curAnim = self.props.animations && self.props.animations.find(function(a) { return String(a.id) === String(self.props.animationSelectCurrent); });
    var curVerName = curAnim ? (curAnim.final ? '\u6700\u7D42\u7A3F' : (curAnim.title || '\u6700\u7D42\u7A3F')) : '\u6700\u7D42\u7A3F';
    item1.innerHTML = '<span class="tm-sort-item-label" id="tm-sort-ver-label">Ver. ' + curVerName + ' <span style="font-size:14px;">\u25BC</span></span><span class="tm-sort-iicon" data-type="ver">i</span>';
    addTap(item1, function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('tm-sort-iicon')) return;
      e.stopPropagation();
      // バージョンドロップダウンをitem1真下に表示（DOM操作方式）
      var verModal = document.getElementById('tm-ver-modal');
      var sortMenu = document.getElementById('tm-sort-menu');
      if (sortMenu) sortMenu.style.display = 'none';
      if (!verModal) return;
      // トグル: 表示中なら閉じる
      if (verModal.style.display === 'block') {
        verModal.style.display = 'none';
        return;
      }
      var animations = self.props.animations || [];
      var currentId = self.props.animationSelectCurrent;
      verModal.innerHTML = '';
      animations.forEach(function(a) {
        var div = document.createElement('div');
        var isSelected = String(a.id) === String(currentId);
        div.className = 'tm-sort-item' + (isSelected ? ' tm-sort-active' : '');
        div.textContent = a.final ? '\u6700\u7D42\u7A3F' : (a.title || String(a.id));
        div.addEventListener('click', function(e) {
          e.stopPropagation();
          var fakeOption = { text: a.final ? '\u6700\u7D42\u7A3F' : (a.title || String(a.id)) };
          var fakeTarget = { value: String(a.id), options: [fakeOption], selectedIndex: 0 };
          self.props.onChangeCommentVersion({ target: fakeTarget });
          verModal.style.display = 'none';
          var sortBodyEl = document.getElementById('tm-sort-body');
          if (sortBodyEl) sortBodyEl.style.display = 'none';
          self.setState({ tmSortAccOpen: false });
        });
        verModal.appendChild(div);
      });
      var itemRect1 = item1.getBoundingClientRect();
      var viewportWidth = window.innerWidth;
      verModal.style.display = 'block';
      verModal.style.top = (itemRect1.bottom + 2) + 'px';
      verModal.style.left = itemRect1.left + 'px';
      verModal.style.minWidth = itemRect1.width + 'px';
      verModal.style.transform = 'none';
      setTimeout(function() {
        var mr = verModal.getBoundingClientRect();
        if (mr.right > viewportWidth - 8) {
          verModal.style.left = Math.max(8, viewportWidth - mr.width - 8) + 'px';
        }
      }, 0);
    });
    body.appendChild(item1);

    // --- 項目2: ↕ 並び順 ---
    var item2 = document.createElement('div');
    item2.className = 'tm-sort-item';
    item2.innerHTML = '<span class="tm-sort-item-icon">\u2195</span><span class="tm-sort-item-label" id="tm-sort-order-label">' + self._getSortLabel() + '</span><span class="tm-sort-iicon" data-type="sort">i</span>';
    addTap(item2, function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('tm-sort-iicon')) return;
      e.stopPropagation();
      // 並び順DDをitem2真下に表示（DOM操作方式）
      var sortMenu = document.getElementById('tm-sort-menu');
      var verModal = document.getElementById('tm-ver-modal');
      if (verModal) verModal.style.display = 'none';
      if (!sortMenu) return;
      // トグル: 表示中なら閉じる
      if (sortMenu.style.display === 'block') {
        sortMenu.style.display = 'none';
        return;
      }
      var items = self._getSortItems();
      sortMenu.innerHTML = '';
      items.forEach(function(item) {
        var div = document.createElement('div');
        div.className = 'tm-sort-item' +
          (self.state.sortComment === item.value ? ' tm-sort-active' : '');
        div.textContent = item.label;
        div.addEventListener('click', function(ev) {
          ev.stopPropagation();
          self._handleTmSortChange(item.value);
          sortMenu.style.display = 'none';
        });
        sortMenu.appendChild(div);
      });
      var itemRect2 = item2.getBoundingClientRect();
      var viewportWidth2 = window.innerWidth;
      sortMenu.style.display = 'block';
      sortMenu.style.top = (itemRect2.bottom + 2) + 'px';
      sortMenu.style.left = itemRect2.left + 'px';
      sortMenu.style.minWidth = itemRect2.width + 'px';
      setTimeout(function() {
        var mr = sortMenu.getBoundingClientRect();
        if (mr.right > viewportWidth2 - 8) {
          sortMenu.style.left = Math.max(8, viewportWidth2 - mr.width - 8) + 'px';
        }
      }, 0);
    });
    body.appendChild(item2);

    // --- 項目3: ☑ 全て表示 ---
    var item3 = document.createElement('div');
    item3.className = 'tm-sort-item';
    item3.id = 'tm-sort-item-showall';
    var cb3 = makeCheckbox('tm-sort-cb-showall', self.state.shouldShowAll);
    var label3 = document.createElement('span');
    label3.className = 'tm-sort-item-label';
    label3.id = 'tm-sort-showall-label';
    label3.textContent = '\u5168\u3066\u8868\u793A';
    var icon3 = document.createElement('span');
    icon3.className = 'tm-sort-iicon';
    icon3.dataset.type = 'showall';
    icon3.textContent = 'i';
    item3.appendChild(cb3);
    item3.appendChild(label3);
    item3.appendChild(icon3);
    addTap(item3, function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('tm-sort-iicon')) return;
      e.stopPropagation();
      // 既存の onChangeCheck を呼ぶ
      self.onChangeCheck({ target: { checked: !self.state.shouldShowAll } });
      // アコーディオンを閉じる
      self.setState({ tmSortAccOpen: false });
    });
    body.appendChild(item3);

    // --- 項目4: 外部には非表示にする（ownerのみ表示）---
    if (isInternal) {
      var item4 = document.createElement('div');
      item4.className = 'tm-sort-item';
      item4.id = 'tm-sort-item-team';
      var cb4 = makeCheckbox('tm-sort-cb-team', self.state.isMarkerDisplayToCollaborators);
      var label4 = document.createElement('span');
      label4.className = 'tm-sort-item-label';
      label4.id = 'tm-sort-team-label';
      label4.textContent = '\u5916\u90E8\u306B\u306F\u975E\u8868\u793A\u306B\u3059\u308B';
      var icon4 = document.createElement('span');
      icon4.className = 'tm-sort-iicon';
      icon4.dataset.type = 'team';
      icon4.textContent = 'i';
      item4.appendChild(cb4);
      item4.appendChild(label4);
      item4.appendChild(icon4);
      addTap(item4, function(e) {
        if (e.target && e.target.classList && e.target.classList.contains('tm-sort-iicon')) return;
        e.stopPropagation();
        // 既存の onClickToggleMarkersFromCollaborator（API POST）を呼ぶ
        var handler = self.props.onClickToggleMarkersFromCollaborator;
        if (handler) {
          handler({ target: { checked: !self.state.isMarkerDisplayToCollaborators }, preventDefault: function(){} });
        }
        // アコーディオンを閉じる
        self.setState({ tmSortAccOpen: false });
      });
      body.appendChild(item4);
    }

    document.body.appendChild(body);

    // iアイコンのイベント（モーダル表示）— addTapでclick+touchend両方登録
    body.querySelectorAll('.tm-sort-iicon').forEach(function(icon) {
      addTap(icon, function(e) {
        e.stopPropagation();
        var type = icon.dataset.type;
        var newState = {
          tmVerInfoModalOpen: false,
          tmSortInfoModalOpen: false,
          tmShowAllModalOpen: false,
          tmTeamModalOpen: false
        };
        if (type === 'ver') newState.tmVerInfoModalOpen = !self.state.tmVerInfoModalOpen;
        else if (type === 'sort') newState.tmSortInfoModalOpen = !self.state.tmSortInfoModalOpen;
        else if (type === 'showall') newState.tmShowAllModalOpen = !self.state.tmShowAllModalOpen;
        else if (type === 'team') {
          newState.tmTeamModalOpen = !self.state.tmTeamModalOpen;
          self.setState(newState, function() {
            var modal = document.getElementById('tm-team-modal');
            if (modal) {
              modal.style.cssText = 'position:fixed !important; transform:none !important; ' +
                'top:50% !important; left:50% !important; ' +
                'margin-top:-100px; margin-left:-200px; ' +
                'z-index:10201; width:400px; max-width:90vw; visibility:visible !important;';
            }
          });
          return;
        }
        self.setState(newState);
      });
    });

    this._sortBodyEl = body;

    // #tm-sort-menu を document.body 直下に生成
    var existingMenu = document.getElementById('tm-sort-menu');
    if (existingMenu) existingMenu.remove();
    var sortMenu = document.createElement('div');
    sortMenu.id = 'tm-sort-menu';
    sortMenu.style.display = 'none';
    sortMenu.style.position = 'fixed';
    sortMenu.style.zIndex = '10200';
    sortMenu.addEventListener('click', function(e) { e.stopPropagation(); });
    document.body.appendChild(sortMenu);
    this._sortMenuEl = sortMenu;

    // #tm-ver-modal を document.body 直下に生成
    var existingVerModal = document.getElementById('tm-ver-modal');
    if (existingVerModal) existingVerModal.remove();
    var verModal = document.createElement('div');
    verModal.id = 'tm-ver-modal';
    verModal.style.display = 'none';
    verModal.style.position = 'fixed';
    verModal.style.zIndex = '10200';
    verModal.addEventListener('click', function(e) { e.stopPropagation(); });
    document.body.appendChild(verModal);
    this._verModalEl = verModal;
  }

  _updateSortBodyLabels() {
    const { animations, animationSelectCurrent } = this.props;

    // バージョンラベル更新（「Ver. xxx」形式）
    var verLabel = document.getElementById('tm-sort-ver-label');
    if (verLabel) {
      var animation = animations && animations.find(function(a) { return String(a.id) === String(animationSelectCurrent); });
      var verName = animation
        ? (animation.final ? '\u6700\u7D42\u7A3F' : (animation.title || '\u6700\u7D42\u7A3F'))
        : '\u6700\u7D42\u7A3F';
      verLabel.innerHTML = 'Ver. ' + verName + ' <span style="font-size:14px;">\u25BC</span>';
    }
    // 並び順ラベル更新（既存の_getSortLabel()をそのまま使用）
    var orderLabel = document.getElementById('tm-sort-order-label');
    if (orderLabel) {
      orderLabel.textContent = this._getSortLabel();
    }
    // 全て表示チェックボックス同期
    var cb3 = document.getElementById('tm-sort-cb-showall');
    if (cb3) {
      cb3.checked = this.state.shouldShowAll;
    }
    // 外部非表示チェックボックス同期（isMarkerDisplayToCollaborators と連動）
    var cb4 = document.getElementById('tm-sort-cb-team');
    if (cb4) {
      cb4.checked = this.state.isMarkerDisplayToCollaborators;
    }
    this._updateSortToggleLabel();
  }

  _updateSortToggleLabel() {
    var label = document.getElementById('tm-sort-toggle-label');
    if (label) label.textContent = this._getSortToggleLabel();
  }

  // [2026-03-30] sort実装 終了

  render() {
    const { disabled, mobile, currentUserId, owner, role: currentUserRole, currentAnimationTotalSize,
            currentAnimationId, onChangePage, currentPageId, pages, animations, role, onChangeCommentVersion,
            animationSelectCurrent, setCurrentAnimation, isShowFullscreenAnimation, isShowDrawComponent, showMode,
            onClickToggleMarkersFromCollaborator, isIpad } = this.props;
    const { shouldShowAll, temp, shouldShowUpdateMarker, body, isSubmitting, sortComment, isMarkerDisplayToCollaborators } = this.state;
    const unsubmittable = isSubmitting || body.length === 0;
    var showMarkerSection = '';
    if (temp){
      showMarkerSection = this.markersSection(this.markers());
    }
    var versionSelector = "version-selector-comment pb-0 pt-0 text-left d-flex align-items-center pl-0 pr-0";
    if(!this.isVideo()){
      versionSelector = versionSelector.concat(" version-selector-image")
    }
    let classAnimationMarker = isShowFullscreenAnimation ? 'animation-markers-pane d-none' : 'animation-markers-pane'
    if (isIpad) {
      classAnimationMarker = classAnimationMarker.concat(' ipad');
    }
    let classForImageAndmMobile = mobile && !this.isVideo() ? 'show-animation-markers-pane-for-image-mobile' : ''
    return (
      <div className={`${ classAnimationMarker } ${classForImageAndmMobile} ${ showMode == 'compare' && 'd-none' }`}>
        {/* ===== sort▽ トグルボタン ===== */}
        <div className="tm-sort-toggle-wrap">
          <button
            id="tm-sort-toggle"
            className={this.state.tmSortAccOpen ? 'tm-open' : ''}
            onClick={() => {
              const toolBody = document.getElementById('tm-tool-body');
              const toolToggle = document.getElementById('tm-tool-toggle');
              if (toolBody && toolBody.style.display !== 'none') {
                toolBody.style.display = 'none';
                if (toolToggle) toolToggle.classList.remove('tm-open');
              }
              this.setState(prev => ({
                tmSortAccOpen: !prev.tmSortAccOpen,
                tmSortMenuOpen: false,
                tmVerModalOpen: false,
                tmSortInfoModalOpen: false,
                tmShowAllModalOpen: false,
                tmTeamModalOpen: false,
                tmVerInfoModalOpen: false,
              }), () => {
                this._positionSortBody();
                if (!this.state.tmSortAccOpen) {
                  var menu = document.getElementById('tm-sort-menu');
                  var verModal = document.getElementById('tm-ver-modal');
                  var ipadDD = document.getElementById('tm-ipad-version-dd');
                  if (menu) menu.style.display = 'none';
                  if (verModal) verModal.style.display = 'none';
                  if (ipadDD) ipadDD.style.display = 'none';
                }
              });
            }}
          >
            <span id="tm-sort-toggle-label">{this._getSortToggleLabel()}</span>
            <span id="tm-sort-toggle-arrow">▽</span>
          </button>
        </div>
        {/* 既存header（非表示だがモーダル・セレクタはDOM内に保持） */}
        <div className="header row d-flex flex-wrap align-items-ceter" style={{height:0,overflow:'hidden',padding:0,margin:0,border:'none',visibility:'hidden'}}>
          <div className={`${versionSelector} select-page-animation-container`} data-tip data-for="sign-up-promotion-tooltip">
            <div id="select-current-page-animation" className='truncate line-clamp-1'>{pages.find(_ => _.id === parseInt(currentPageId))?.title}</div>
          </div>
          {/* iPad: カスタムドロップダウン */}
          {typeof window !== 'undefined' && (/iPad/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) ? (
            <div className={`${versionSelector} select-comment-animation-container`}
              style={{position:'relative'}}>
              <div
                style={{
                  background:'#222',color:'#fff',border:'1px solid #555',
                  borderRadius:'4px',padding:'4px 24px 4px 8px',cursor:'pointer',
                  fontSize:'13px',whiteSpace:'nowrap',overflow:'hidden',
                  textOverflow:'ellipsis',maxWidth:'180px',position:'relative',
                  userSelect:'none'
                }}
                onClick={() => {
                  var dd = document.getElementById('tm-ipad-version-dd');
                  if (dd) dd.style.display = dd.style.display === 'none' ? 'block' : 'none';
                }}
              >
                {version(animations.find(a => a.id == animationSelectCurrent) || animations[0] || {})}
                <span style={{position:'absolute',right:'6px',top:'50%',transform:'translateY(-50%)'}}>▼</span>
              </div>
              <div id="tm-ipad-version-dd" style={{
                display:'none',position:'fixed',
                left:'50%',transform:'translateX(-50%)',
                top:'auto',bottom:'120px',
                background:'#222',border:'1px solid #888',borderRadius:'6px',
                zIndex:2147483600,minWidth:'220px',maxHeight:'60vh',overflowY:'auto',
                boxShadow:'0 4px 16px rgba(0,0,0,0.6)'
              }}>
                {animations.map((animation, i) => (
                  <div key={i}
                    style={{
                      padding:'10px 16px',color:'#fff',fontSize:'13px',
                      borderBottom:'1px solid #444',cursor:'pointer'
                    }}
                    onTouchEnd={(e) => {
                      e.preventDefault();
                      document.getElementById('tm-ipad-version-dd').style.display = 'none';
                      onChangeCommentVersion({ target: { value: animation.id } });
                    }}
                  >
                    {version(animation)}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            /* PC: 既存の<select>をそのまま残す */
            <div className={`${versionSelector} select-comment-animation-container`} data-tip data-for="sign-up-promotion-tooltip">
              <Input type="select" id="animation-selector-comemnt" value={animationSelectCurrent || ''}
                      onChange={(e) => {
                        onChangeCommentVersion(e);
                        const hideAkaireModal = () => {
                          if (window.Swal && typeof window.Swal.close === 'function') window.Swal.close();
                          document.querySelectorAll('.swal2-container, .akaire_alert_popup_container, .modal.show, .modal-backdrop, [class*="akaire_alert_popup"]')
                            .forEach(el => el.style.setProperty('display', 'none', 'important'));
                        };
                        setTimeout(hideAkaireModal, 50);
                        setTimeout(hideAkaireModal, 150);
                        setTimeout(hideAkaireModal, 400);
                      }} disabled={!canSwitchVersion(role, animations)} >
                {
                  animations.map((animation, i) => {
                    return (
                      <option value={animation.id} key={i}>
                        {version(animation)}
                      </option>
                    );
                  })
                }
              </Input>
            </div>
          )}
          {/* [2026-03-30] バージョンiアイコン 開始 — select-comment-animation-containerの外側に配置 */}
          <span
            className="tm-info-icon"
            id="tm-ver-info-icon"
            onClick={(e) => {
              e.stopPropagation();
              this.setState(s => ({ tmVerModalOpen: false, tmSortMenuOpen: false }));
            }}
          >i</span>
          {/* [2026-03-30] バージョンiアイコン 終了 */}
          { mobile && !this.isVideo() && (
            <div style={{ color: 'white', cursor: 'pointer' }} className={`d-flex align-items-center `}>
               {bytes(currentAnimationTotalSize)}
            </div>
          )}
          {/* [2026-03-30] 元コード start
          {
            <div className='d-flex text-white align-items-center text-underline dropdown-toggle dropdown-toggle-split change-sort-comemnt-akaire p-0'
                 data-toggle={isShowDrawComponent ? '' : "dropdown"} aria-haspopup="true" aria-expanded="false">
              <span className=''>{ this.isVideo() ? sortComment === 'asc' ? '尺昇順' : '尺降順' : sortComment === 'asc' ? 'No 昇順' : 'No 降順' } </span>
              <div className={isShowDrawComponent ? 'd-none dropdown-for-change-sort-comment-akaire' :"dropdown-menu dropdown-for-change-sort-comment-akaire"}>
                  <div className={`dropdown-item first ${sortComment === 'asc' ? 'active' : ''}`}
                       onMouseDown={() => this.changeSortComment('asc')}>{this.isVideo() ? 'コメント並び順（尺昇順）' : 'コメント並び順（No 昇順）'}</div>
                  <div className={`dropdown-item last ${sortComment === 'desc' ? 'active' : ''}`}
                       onMouseDown={() => this.changeSortComment('desc')}>{this.isVideo() ? 'コメント並び順（尺降順）' : 'コメント並び順（No 降順）'}</div>
              </div>
            </div>
          }
          [2026-03-30] 元コード end */}
          {/* [2026-03-30] sort実装 開始 */}
          <span id="tm-sort-icon-wrap" onClick={e => e.stopPropagation()}>
            <button
              className="change-sort-comemnt-akaire"
              onClick={(e) => {
                e.stopPropagation();
                this.setState(s => ({ tmSortMenuOpen: !s.tmSortMenuOpen, tmVerModalOpen: false, tmSortInfoModalOpen: false, tmShowAllModalOpen: false }));
              }}
            >
              <span>{this._getSortLabel()}</span>
            </button>
            <span
              className="tm-info-icon"
              onClick={(e) => {
                e.stopPropagation();
                this.setState(s => ({ tmSortInfoModalOpen: !s.tmSortInfoModalOpen, tmSortMenuOpen: false }));
              }}
            >i</span>
            {/* [2026-04-02] #tm-sort-menu は隠しheaderの外（render末尾）に移動 */}
            {this.state.tmSortInfoModalOpen && (
              <>
                <div className="tm-modal-backdrop" onClick={(e) => { e.stopPropagation(); this.setState({ tmSortInfoModalOpen: false }); }} />
                <div className="tm-modal-body" id="tm-sort-info-modal" style={{visibility:'visible'}} onClick={e => e.stopPropagation()}>
                  <div className="tm-modal-title">並び順について</div>
                  <div className="tm-modal-box">
                    コメントツールの並び順を変更します。<br/>
                    <br/>【動画・YouTube】<br/>
                    ・尺順（先頭から）：タイムライン昇順<br/>
                    ・尺順（後ろから）：タイムライン降順<br/>
                    <br/>【画像・PDF・Web】<br/>
                    ・古い順（No 昇順）<br/>
                    ・新しい順（No 降順）
                  </div>
                </div>
              </>
            )}
          </span>
          {/* [2026-03-30] sort実装 終了 */}

          <FormGroup check className="pl-0 d-flex align-items-center">
            <Input type="checkbox" className="mr-1 mt-0 ml-0" style={{ width: '18px', height: '18px', position: 'static', transform: 'initial' }} checked={shouldShowAll} onChange={isShowDrawComponent ? null : this.onChangeCheck} disabled={disabled} />
            {
              mobile ? (
                <span className="text-of-input-check text-light">完了済も全て表示</span>
              ) : (
                /* [2026-03-30] 元コード: <span className="text-of-input-check text-light">全て表示</span> */
                <span className="text-of-input-check text-light">全て</span>
              )
            }
                {/* [2026-03-30] 全てiアイコン 開始 */}
                {!mobile && (
                  <span
                    className="tm-info-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState(s => ({ tmShowAllModalOpen: !s.tmShowAllModalOpen, tmSortMenuOpen: false }));
                    }}
                  >i</span>
                )}
                {this.state.tmShowAllModalOpen && (
                  <>
                    <div className="tm-modal-backdrop" onClick={(e) => { e.stopPropagation(); this.setState({ tmShowAllModalOpen: false }); }} />
                    <div className="tm-modal-body" id="tm-showall-modal" style={{visibility:'visible'}} onClick={e => e.stopPropagation()}>
                      <div className="tm-modal-title">「全て」チェックについて</div>
                      ・チェックすると全てのコメントを表示<br/>
                      ・チェックを外すと未確認(✓なし)のコメントのみ表示します。
                    </div>
                  </>
                )}
                {/* [2026-03-30] 全てiアイコン 終了 */}

          </FormGroup>

          {/* [2026-04-02] 外部非表示iアイコンモーダル */}
          {this.state.tmTeamModalOpen && (
            <>
              <div className="tm-modal-backdrop" onClick={() => this.setState({ tmTeamModalOpen: false })} />
              <div className="tm-modal-body" id="tm-team-modal" style={{position:'fixed', zIndex:10101, visibility:'visible'}}
                   onClick={e => e.stopPropagation()}>
                <div className="tm-modal-title">外部には非表示にする</div>
                <div className="tm-modal-box">
                  チェックを入れると、チームメンバーのコメントを外部メンバーに非表示にできます。
                </div>
                <div className="tm-modal-box">
                  ・チームメンバー：すべてのコメントを閲覧できます。<br/>
                  ・外部メンバー：自身が投稿したコメントのみ閲覧・更新できます。
                </div>
                <div className="tm-modal-box">
                  ※チェックを外すと、招待済みの全メンバーにコメントが表示されます。
                </div>
              </div>
            </>
          )}

        </div>
        <Modal isOpen={shouldShowUpdateMarker}>
          <Form
            onSubmit={this.onSubmitUpdateMarker}
          >
            <ModalHeader>
              コメントを変更する
            </ModalHeader>
            <ModalBody>
              <Input type="textarea" value={body} autoFocus onChange={this.onChangeBody} rows={4}/>
            </ModalBody>
            <ModalFooter>
              <div className="d-flex justify-content-between">
                <Button onClick={ () => this.close('UpdateMarker') } className="cancel mr-2">
                  キャンセル
                </Button>
                <Button type="submit" disabled={unsubmittable} className="submit btn btn-danger" color='primary'>
                  保存
                </Button>
              </div>
            </ModalFooter>
          </Form>
        </Modal>
        {
          showMarkerSection
        }
        {this.markersForm()}
        {/* {this.publicUserLogin() && this.renderPromotionTooltip()} */}
        {/* {this.puplicUserNotPermission() && this.renderUnregisterUserTooltip()} */}

        {/* [2026-04-02] #tm-sort-menu と #tm-ver-modal は document.body直下にDOM操作で追加 */}

        {/* [2026-04-02] バージョン説明モーダル（iアイコン用） */}
        {this.state.tmVerInfoModalOpen && (
          <>
            <div className="tm-modal-backdrop" onClick={() => this.setState({ tmVerInfoModalOpen: false })} />
            <div className="tm-modal-body" id="tm-ver-info-modal" style={{width:480,maxWidth:'90vw'}}
                 onClick={e => e.stopPropagation()}>
              <div className="tm-modal-title">メディア画面と異なるバージョンのコメントを表示する</div>
              <div className="tm-modal-box">
                ここでは、コメントツールのバージョンを切り替えることで、<br/>
                メディア画面と比較しながら確認できます。<br/>
                投稿されたコメントが、別のバージョンで修正済みかどうかを<br/>
                確認したい場合に便利です。
              </div>
              <div className="tm-modal-box">
                ・メディア画面では（例）Ver.02 を表示<br/>
                ・コメントツールでは（例）Ver.01 を表示<br/>
                にすることで、修正が反映されているか見比べて確認しやすくなります。
              </div>
              <div className="tm-modal-box">
                また、コメントツールのバージョンを切り替えている間に、<br/>
                メディア画面に新しいコメントを追加すると、<br/>
                コメントツールのバージョン切り替えが解除されます。
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
};
